export default "__VITE_ASSET__CMDiXhhG__"